import Device from '../model/Device';
import Time from '../model/Time';
import Game from '../model/Game';
import GameProduct from '../model/GameProduct';
import Role from '../model/Role';
import User from '../model/User';
import ChannelPlatform from '../model/ChannelPlatform';

function Connector() {}

Connector.prototype = {
  constructor: Connector,
  getDevice: () => new Device(),
  getUser: () => new User(),
  getTime: () => Time.getTime(),
  // eslint-disable-next-line
  getSign: (obj) => '',
  getGame: () => new Game(),
  getGameProduct: () => new GameProduct(),
  getRole: () => new Role(),
  callExit: () => {},
  finishPay: () => {},
  getChannelPlatform: () => new ChannelPlatform(),
  // eslint-disable-next-line
  onEvent: (event, jsonStr) => {},
  getUrls: () => {},
  openDetail: () => {},
  // eslint-disable-next-line
  notifyPayResult: (jsonStr) => {},
  // eslint-disable-next-line
  pay: (payChannelId, params) => {},
};

export default Connector;



// WEBPACK FOOTER //
// ./src/common/js/native/prototype.js